import React, { useState } from 'react';
import {PaginationItem, PaginationLink } from 'reactstrap';

export function PageItem ({ numberPage, getNumberPage }) {

  const [ number ] = useState(numberPage);

  const hasClick = (event)=> {
    event.preventDefault();
    getNumberPage(number)
  }

  return (
    <PaginationItem onClick={hasClick}>
    <PaginationLink>
      {numberPage}
    </PaginationLink>
  </PaginationItem>
  );
}
